<mat-stepper [orientation]="isHandset ? 'vertical' : 'horizontal'" #stepper>

  <!-- STEP 1: Osnovni podaci o proračunu -->
  <mat-step label="1. Osnovni podaci o proračunu">
    <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
      <mat-card-header>
        <mat-card-title>
          <h5 class="mb-0">1. Osnovni podaci o proračunu</h5>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        @if (budgetInfoFieldValues && budgetInfoFieldValues.length > 0) {
          @for (field of budgetInfoFieldValues; track field) {
            <div class="mb-25">
              @if (field.value !== null && field.value !== undefined) {
                <p>
                  <strong>{{ field.label }}:</strong>
                  <span>
                    @switch (field.type) {
                      <!-- Example for an enum (ProjectBudgetType) -->
                      @case ('enum') {
                        {{ getBudgetTypeLabel(field.value) }}
                      }
                      <!-- Just show numeric / default values -->
                      @default {
                        {{ field.value }}
                      }
                    }
                  </span>
                </p>
              }
            </div>
          }
        } @else {
          <p>Nema dostupnih informacija o proračunu.</p>
        }

      </mat-card-content>
    </mat-card>
  </mat-step>

  <!-- STEP 2: Izravni troškovi -->
  <mat-step label="2. Izravni troškovi">
    @if (directBudgetItems && directBudgetItems.length > 0) {
      @for (item of directBudgetItems; track item) {
        <div class="mb-25">
          <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-content>
              <p><strong>Vrsta troška:</strong> {{ item.description }}</p>
              <p><strong>Iznos tražen od Općine:</strong> {{ item.amountRequested | currency:'EUR' }}</p>
              <p><strong>Ukupan iznos troška:</strong> {{ item.totalAmount | currency:'EUR' }}</p>
              <p><strong>Objašnjenje proračunske stavke:</strong> {{ item.explanation }}</p>
              <!-- Priloženi dokumenti za ovaj budget item (ako postoje) -->
              @if (budgetItemFileMap[item.id] && budgetItemFileMap[item.id].length > 0) {
                <p><strong>Priložena dokumentacija:</strong></p>
                <ul>
                  @for (file of budgetItemFileMap[item.id]; track file) {
                    <li>
                      <a (click)="downloadFile(file)" class="download-link">
                        {{ file.name }}
                      </a>
                    </li>
                  }
                </ul>
              }
            </mat-card-content>
          </mat-card>
        </div>
      }
    } @else {
      <p>Nema evidentiranih izravnih troškova.</p>
    }

    <!-- Ukupno izravni troškovi -->
    @if (budget) {
      <div class="totals mt-25">
        <h4>
          Ukupno POGLAVLJE A) IZRAVNI TROŠKOVI (traženo / ukupno):
          {{ budget.totalDirectCostsRequested | currency:'EUR' }} /
          {{ budget.totalDirectCostsActual | currency:'EUR' }}
        </h4>
      </div>
    }
  </mat-step>

  <!-- STEP 3: Neizravni troškovi -->
  <mat-step label="3. Neizravni troškovi">
    @if (indirectBudgetItems && indirectBudgetItems.length > 0) {
      @for (item of indirectBudgetItems; track item) {
        <div class="mb-25">
          <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-content>
              <p><strong>Vrsta troška:</strong> {{ item.description }}</p>
              <p><strong>Iznos tražen od Općine:</strong> {{ item.amountRequested | currency:'EUR' }}</p>
              <p><strong>Ukupan iznos troška:</strong> {{ item.totalAmount | currency:'EUR' }}</p>
              <p><strong>Objašnjenje proračunske stavke:</strong> {{ item.explanation }}</p>
              <!-- Priloženi dokumenti za ovaj budget item (ako postoje) -->
              @if (budgetItemFileMap[item.id] && budgetItemFileMap[item.id].length > 0) {
                <p><strong>Priložena dokumentacija:</strong></p>
                <ul>
                  @for (file of budgetItemFileMap[item.id]; track file) {
                    <li>
                      <a (click)="downloadFile(file)" class="download-link">
                        {{ file.name }}
                      </a>
                    </li>
                  }
                </ul>
              }
            </mat-card-content>
          </mat-card>
        </div>
      }
    } @else {
      <p>Nema evidentiranih neizravnih troškova.</p>
    }

    <!-- Ukupno neizravni troškovi -->
    @if (budget) {
      <div class="totals mt-25">
        <h4>
          Ukupno POGLAVLJE B) NEIZRAVNI TROŠKOVI (traženo / ukupno):
          {{ budget.totalIndirectCostsRequested | currency:'EUR' }} /
          {{ budget.totalIndirectCostsActual | currency:'EUR' }}
        </h4>
      </div>
    }
  </mat-step>

  <!-- STEP 4: Ostali izvori financiranja -->
  <mat-step label="4. Ostali izvori financiranja">
    @if (budget && budget.projectFundingSources && budget.projectFundingSources.length > 0) {
      @for (source of budget.projectFundingSources; track source; let i = $index) {
        <div class="mb-25">
          <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
            <mat-card-content>
              <p><strong>Vrsta izvora:</strong> {{ getFundingSourceTypeLabel(source.type) }}</p>
              <p><strong>Iznos:</strong> {{ source.amount | currency:'EUR' }}</p>
            </mat-card-content>
          </mat-card>
        </div>
      }
      <div class="totals">
        <h4>Ukupno iz ostalih izvora: {{ budget.totalFundingFromOtherSources | currency:'EUR' }}</h4>
      </div>
    } @else {
      <p>Nema evidentiranih ostalih izvora financiranja.</p>
    }
  </mat-step>

  <!-- STEP 5: Sumarni prikaz ukupnih troškova -->
  <mat-step label="5. Sumarni prikaz">
    @if (budget) {
      <mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block">
        <mat-card-content>
          <!-- 1) Izravni troškovi (A) -->
          <div class="mb-25">
            <h3>Izravni troškovi (A)</h3>
            <p>
              <strong>Ukupan iznos tražen od Općine:</strong> {{ budget.totalDirectCostsRequested | currency:'EUR' }}<br>
              <strong>Ukupan iznos troška:</strong> {{ budget.totalDirectCostsActual | currency:'EUR' }}
            </p>
          </div>
          <!-- 2) Neizravni troškovi (B) -->
          <div class="mb-25">
            <h3>Neizravni troškovi (B)</h3>
            <p>
              <strong>Ukupan iznos tražen od Općine:</strong> {{ budget.totalIndirectCostsRequested | currency:'EUR' }}<br>
              <strong>Ukupan iznos troška:</strong> {{ budget.totalIndirectCostsActual | currency:'EUR' }}
            </p>
          </div>
          <!-- 3) Sveukupno (A + B) -->
          <div class="mb-25">
            <h3>Sveukupno (A + B)</h3>
            <p>
              <strong>Ukupan iznos tražen od Općine:</strong> {{ budget.totalCostsRequested | currency:'EUR' }}<br>
              <strong>Ukupan iznos troška:</strong> {{ budget.totalCostsActual | currency:'EUR' }}
            </p>
          </div>
          <!-- 4) Ostali izvori financiranja -->
          <div class="mb-25">
            <h3>Ostali izvori financiranja</h3>
            <p>
              <strong>Ukupan iznos:</strong> {{ budget.totalFundingFromOtherSources | currency:'EUR' }}
            </p>
          </div>
          <!-- 5) Sveukupni iznos troškova (svi izvori) -->
          <div class="mb-25">
            <h3>Sveukupni iznos troškova (svi izvori)</h3>
            <p>
              <strong>Iznos:</strong> {{ budget.totalFunding | currency:'EUR' }}
            </p>
          </div>
        </mat-card-content>
      </mat-card>
    }
  </mat-step>

</mat-stepper>
